/**
 * Media hero: transparent header on desktop only when overlay_header is enabled.
 */
(function () {
  'use strict';

  function init() {
    var el = document.querySelector('[data-media-hero-prevent]');
    if (!el) return;
    var mq = window.matchMedia('(min-width: 750px)');
    var headerWrapper = document.querySelector('[data-header-wrapper]');

    function check(e) {
      if (e.matches) {
        el.removeAttribute('data-prevent-transparent-header');
        if (headerWrapper) headerWrapper.setAttribute('data-header-transparent', '');
      } else {
        el.setAttribute('data-prevent-transparent-header', '');
        if (headerWrapper) headerWrapper.removeAttribute('data-header-transparent');
      }
    }

    mq.addEventListener('change', check);
    check(mq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
